import React, { Component } from "react";
import { Table, Button, Col, Row, Tooltip, Icon } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class AtividadesVendedoresPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {

    }


    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span></span>
        }
    }

    renderVenda = (text, registro) => {
        return (
            <span>
                <span>{registro.ativv_idf_venda ? 'SIM' : 'NÃO'}</span>
            </span>
        );
    };


    renderAtividade = (text, registro) => {
        let check;

        if (!registro.ativ_data_checkin) {
            if ((registro.ativ_hora_ini) && (registro.ativ_hora_ini != '00:00')) {
                const date1 = new Date();
                const date2 = moment(registro.ativ_data_ativ).format('DD/MM/YYYY') + ' ' + registro.ativ_hora_ini + ':00';
                if (moment(date1, "DD/MM/YYYY HH:mm:ss").diff(moment(date2, "DD/MM/YYYY HH:mm:ss")) >= 0) {
                    check = 0
                } else {
                    check = 1
                }
            } else {
                check = 0
            }
        } else if (!registro.ativ_data_checkout) {
            if ((registro.ativ_hora_fim) && (registro.ativ_hora_fim != '00:00')) {
                const date1 = new Date();
                const date2 = moment(registro.ativ_data_ativ).format('DD/MM/YYYY') + ' ' + registro.ativ_hora_fim + ':00';
                if (moment(date1, "DD/MM/YYYY HH:mm:ss").diff(moment(date2, "DD/MM/YYYY HH:mm:ss")) >= 0) {
                    check = 0
                } else {
                    check = 1
                }
            } else {
                check = 0
            }
        } else {
            check = 0
        }

        return (
            <div>
                {(registro.ativ_data_checkin && registro.ativ_data_checkout) ? (
                    <Icon type="check-circle" style={{ marginRight: 5, color: "#10734a" }} />
                ) : (
                    check ? (
                        <Icon type="calendar" style={{ marginRight: 5, color: "#f9a825" }} />
                    ) : (
                        <Icon type="close-circle" style={{ marginRight: 5, color: "#b71c1c" }} />
                    )
                )}
                <span>{registro.ac_descricao}</span>
            </div>
        )
    };

    renderCliente = (text, registro) => {
        return (
            <span>
                <Icon type={registro.ativv_cliente ? "user" : "user-delete"} style={{ fontSize: 25, marginRight: 5, color: registro.ativv_cliente ? "#10734a" : "#b71c1c" }} />
                <span>{registro.ativv_cliente ? registro.pes_nome : registro.ativv_nome_cliente}</span>
            </span>
        );
    };

    renderKm = (text, registro) => {
        const kmRodado = parseFloat(registro.ativa_km_ini) > 0 && parseFloat(registro.ativa_km_fim) > 0 ? parseFloat(registro.ativa_km_fim) - parseFloat(registro.ativa_km_ini) : 0;
        return (
            <span>
                {kmRodado}
            </span>
        )
    }

    renderValor = (ven_vlr_total, registro) => {
        return (
            <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
        );
    };

    onAbrirMapaClick = (localizacao) => {
        if (localizacao) {
            window.open("http://maps.google.com/maps?q=" + localizacao, '_blank')
            // window.open("http://maps.google.com/maps?q=" + localizacao, "minhaJanela", "height=400,width=400");
        }
    };

    renderDataCheckIn = (text, registro) => {
        if (registro.ativ_data_checkin) {
            const dataMoment = moment(registro.ativ_data_checkin);
            return (
                <span>
                    <Tooltip title="Abrir Localização no Mapa">
                        <Icon type="pushpin" style={{ marginRight: 5, color: "#10734a" }} />
                        <a onClick={() => this.onAbrirMapaClick(registro.ativ_local_checkin)}>
                            {dataMoment.format('DD/MM/YYYY HH:mm')}
                        </a>
                    </Tooltip>
                </span >
            )
        } else {
            return (
                <span>
                    <Icon type="close-circle" style={{ marginRight: 5, color: "#b71c1c" }} />
                    <span>SEM CHECK-IN</span>
                </span>
            )
        }
    }

    renderDataCheckOut = (text, registro) => {
        if (registro.ativ_data_checkout) {
            const dataMoment = moment(registro.ativ_data_checkout);
            return (
                <span>
                    <Tooltip title="Abrir Localização no Mapa">
                        <a
                            onClick={() => this.onAbrirMapaClick(registro.ativ_local_checkout)}
                        >
                            {dataMoment.format('DD/MM/YYYY HH:mm')}
                        </a>
                    </Tooltip>
                </span>
            )
        } else {
            return (
                <span>
                    <Icon type="close-circle" style={{ marginRight: 5, color: "#b71c1c" }} />
                    <span>SEM CHECK-OUT</span>
                </span>
            )
        }
    }





    render() {
        const { carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            Atividades
                        </div>

                        <Row>
                            <Col xs={22} style={{ marginTop: 10, marginLeft: 40, textAlign: "left" }} >
                                <span style={{ fontWeight: "bold" }}>Período: </span>
                                <span>{this.props.buscaDataIni + ' a ' + this.props.buscaDataFim}</span>
                            </Col>
                            <Col xs={22} style={{ marginTop: 0, marginLeft: 40, marginBottom: 30, textAlign: "left" }} >
                                <span style={{ fontWeight: "bold" }}>Vendedor: </span>
                                <span>{this.props.buscaUsuario}</span>
                            </Col>
                        </Row>


                        {/* ----------------------------------------------------------------- */}
                        {/* VISITAS --------------------------------------------------------- */}
                        {/* ----------------------------------------------------------------- */}

                        {this.props.listaVisitas && this.props.listaVisitas.length > 0 ? (
                            <div style={{ marginBottom: 70 }}>
                                <Col xs={24} style={{ background: "#ececec", padding: 5, marginTop: -15 }}>
                                    <Col xs={24} style={{ paddingRight: 5, paddingLeft: 20, textAlign: "left", background: "white" }} >
                                        <Row><span style={{ fontWeight: "bold", fontSize: 24 }}>VISITAS</span></Row>
                                    </Col>
                                </Col>

                                <div style={{ marginTop: -30 }}>
                                    <Table
                                        pagination={false}
                                        onChange={this.onTabelaChange}
                                        loading={{
                                            spinning: carregando,
                                            tip: 'Carregando. Aguarde...',
                                            size: "large"
                                        }}
                                        dataSource={this.props.listaVisitas}
                                        rowKey={(registro => registro.ativ_idf)}
                                    >
                                        <Column
                                            key="ativ_data_ativ"
                                            dataIndex="ativ_data_ativ"
                                            title="Data"
                                            render={this.renderData}
                                            width={"10%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_hora_ini"
                                            dataIndex="ativ_hora_ini"
                                            title="Início"
                                            width={"5%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_hora_fim"
                                            dataIndex="ativ_hora_fim"
                                            title="Fim"
                                            width={"5%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativv_idf_venda"
                                            dataIndex="ativv_idf_venda"
                                            title="Venda"
                                            render={this.renderVenda}
                                            width={"7%"}
                                            align="left"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativv_nome_cliente"
                                            dataIndex="ativv_nome_cliente"
                                            title="Cliente"
                                            render={this.renderCliente}
                                            width={"15%"}
                                            align="left"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_obs"
                                            dataIndex="ativ_obs"
                                            title="Descrição"
                                            width={"15%"}
                                            align="left"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_data_checkin"
                                            dataIndex="ativ_data_checkin"
                                            title="Check-In"
                                            render={this.renderDataCheckIn}
                                            width={"14%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_data_checkout"
                                            dataIndex="ativ_data_checkout"
                                            title="Check-Out"
                                            render={this.renderDataCheckOut}
                                            width={"14%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                    </Table>
                                </div>
                            </div>
                        ) : null}


                        {/* ----------------------------------------------------------------- */}
                        {/* ESCRITÓRIO ------------------------------------------------------ */}
                        {/* ----------------------------------------------------------------- */}

                        {this.props.listaEscritorio && this.props.listaEscritorio.length > 0 ? (
                            <div style={{ marginBottom: 70 }}>
                                <Col xs={24} style={{ background: "#ececec", padding: 5, marginTop: -15 }}>
                                    <Col xs={24} style={{ paddingRight: 5, paddingLeft: 20, textAlign: "left", background: "white" }} >
                                        <Row><span style={{ fontWeight: "bold", fontSize: 24 }}>ESCRITÓRIO</span></Row>
                                    </Col>
                                </Col>

                                <div style={{ marginTop: -30 }}>
                                    <Table
                                        pagination={false}
                                        onChange={this.onTabelaChange}
                                        loading={{
                                            spinning: carregando,
                                            tip: 'Carregando. Aguarde...',
                                            size: "large"
                                        }}
                                        dataSource={this.props.listaEscritorio}
                                        rowKey={(registro => registro.ativ_idf)}
                                    >
                                        <Column
                                            key="ativ_data_ativ"
                                            dataIndex="ativ_data_ativ"
                                            title="Data"
                                            render={this.renderData}
                                            width={"10%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_hora_ini"
                                            dataIndex="ativ_hora_ini"
                                            title="Início"
                                            width={"5%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_hora_fim"
                                            dataIndex="ativ_hora_fim"
                                            title="Fim"
                                            width={"5%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_obs"
                                            dataIndex="ativ_obs"
                                            title="Descrição"
                                            width={"30%"}
                                            align="left"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_data_checkin"
                                            dataIndex="ativ_data_checkin"
                                            title="Check-In"
                                            render={this.renderDataCheckIn}
                                            width={"14%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_data_checkout"
                                            dataIndex="ativ_data_checkout"
                                            title="Check-Out"
                                            render={this.renderDataCheckOut}
                                            width={"14%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                    </Table>
                                </div>
                            </div>
                        ) : null}


                        {/* ----------------------------------------------------------------- */}
                        {/* TRANSITO -------------------------------------------------------- */}
                        {/* ----------------------------------------------------------------- */}

                        {this.props.listaTransito && this.props.listaTransito.length > 0 ? (
                            <div style={{ marginBottom: 70 }}>
                                <Col xs={24} style={{ background: "#ececec", padding: 5, marginTop: -15 }}>
                                    <Col xs={24} style={{ paddingRight: 5, paddingLeft: 20, textAlign: "left", background: "white" }} >
                                        <Row><span style={{ fontWeight: "bold", fontSize: 24 }}>TRÂNSITO</span></Row>
                                    </Col>
                                </Col>

                                <div style={{ marginTop: -30 }}>
                                    <Table
                                        pagination={false}
                                        onChange={this.onTabelaChange}
                                        loading={{
                                            spinning: carregando,
                                            tip: 'Carregando. Aguarde...',
                                            size: "large"
                                        }}
                                        dataSource={this.props.listaTransito}
                                        rowKey={(registro => registro.ativ_idf)}
                                    >
                                        <Column
                                            key="ativ_data_ativ"
                                            dataIndex="ativ_data_ativ"
                                            title="Data"
                                            render={this.renderData}
                                            width={"10%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_hora_ini"
                                            dataIndex="ativ_hora_ini"
                                            title="Início"
                                            width={"5%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_hora_fim"
                                            dataIndex="ativ_hora_fim"
                                            title="Fim"
                                            width={"5%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativa_km_ini"
                                            dataIndex="ativa_km_ini"
                                            title="Odo Inicial"
                                            width={"8%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativa_km_fim"
                                            dataIndex="ativa_km_fim"
                                            title="Odô Final"
                                            width={"8%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativa_km_rodado"
                                            dataIndex="ativa_km_rodado"
                                            title="Km Rod"
                                            render={this.renderKm}
                                            width={"8%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_obs"
                                            dataIndex="ativ_obs"
                                            title="Descrição"
                                            width={"10%"}
                                            align="left"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_data_checkin"
                                            dataIndex="ativ_data_checkin"
                                            title="Check-In"
                                            render={this.renderDataCheckIn}
                                            width={"14%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_data_checkout"
                                            dataIndex="ativ_data_checkout"
                                            title="Check-Out"
                                            render={this.renderDataCheckOut}
                                            width={"14%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                    </Table>
                                </div>
                            </div>
                        ) : null}


                        {/* ----------------------------------------------------------------- */}
                        {/* ABASTECIMENTOS -------------------------------------------------- */}
                        {/* ----------------------------------------------------------------- */}

                        {this.props.listaAbastec && this.props.listaAbastec.length > 0 ? (
                            <div style={{ marginBottom: 70 }}>
                                <Col xs={24} style={{ background: "#ececec", padding: 5, marginTop: -15 }}>
                                    <Col xs={24} style={{ paddingRight: 5, paddingLeft: 20, textAlign: "left", background: "white" }} >
                                        <Row><span style={{ fontWeight: "bold", fontSize: 24 }}>ABASTECIMENTOS</span></Row>
                                    </Col>
                                </Col>

                                <div style={{ marginTop: -30 }}>
                                    <Table
                                        pagination={false}
                                        onChange={this.onTabelaChange}
                                        loading={{
                                            spinning: carregando,
                                            tip: 'Carregando. Aguarde...',
                                            size: "large"
                                        }}
                                        dataSource={this.props.listaAbastec}
                                        rowKey={(registro => registro.ativ_idf)}
                                    >
                                        <Column
                                            key="ativ_data_ativ"
                                            dataIndex="ativ_data_ativ"
                                            title="Data"
                                            render={this.renderData}
                                            width={"10%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_hora_ini"
                                            dataIndex="ativ_hora_ini"
                                            title="Início"
                                            width={"5%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_hora_fim"
                                            dataIndex="ativ_hora_fim"
                                            title="Fim"
                                            width={"5%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativa_km"
                                            dataIndex="ativa_km"
                                            title="Odômetro"
                                            width={"10%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativa_qtde_comb"
                                            dataIndex="ativa_qtde_comb"
                                            title="Qtde Comb"
                                            render={this.renderValor}
                                            width={"10%"}
                                            align="right"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_obs"
                                            dataIndex="ativ_obs"
                                            title="Descrição"
                                            width={"20%"}
                                            align="left"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_data_checkin"
                                            dataIndex="ativ_data_checkin"
                                            title="Check-In"
                                            render={this.renderDataCheckIn}
                                            width={"14%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_data_checkout"
                                            dataIndex="ativ_data_checkout"
                                            title="Check-Out"
                                            render={this.renderDataCheckOut}
                                            width={"14%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                    </Table>
                                </div>
                            </div>
                        ) : null}


                        {/* ----------------------------------------------------------------- */}
                        {/* OUTROS ---------------------------------------------------------- */}
                        {/* ----------------------------------------------------------------- */}

                        {this.props.listaOutros && this.props.listaOutros.length > 0 ? (
                            <div style={{ marginBottom: 70 }}>
                                <Col xs={24} style={{ background: "#ececec", padding: 5, marginTop: -15 }}>
                                    <Col xs={24} style={{ paddingRight: 5, paddingLeft: 20, textAlign: "left", background: "white" }} >
                                        <Row><span style={{ fontWeight: "bold", fontSize: 24 }}>OUTROS</span></Row>
                                    </Col>
                                </Col>

                                <div style={{ marginTop: -30 }}>
                                    <Table
                                        pagination={false}
                                        onChange={this.onTabelaChange}
                                        loading={{
                                            spinning: carregando,
                                            tip: 'Carregando. Aguarde...',
                                            size: "large"
                                        }}
                                        dataSource={this.props.listaOutros}
                                        rowKey={(registro => registro.ativ_idf)}
                                    >
                                        <Column
                                            key="ativ_data_ativ"
                                            dataIndex="ativ_data_ativ"
                                            title="Data"
                                            render={this.renderData}
                                            width={"10%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_hora_ini"
                                            dataIndex="ativ_hora_ini"
                                            title="Início"
                                            width={"5%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_hora_fim"
                                            dataIndex="ativ_hora_fim"
                                            title="Fim"
                                            width={"5%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_obs"
                                            dataIndex="ativ_obs"
                                            title="Descrição"
                                            width={"30%"}
                                            align="left"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_data_checkin"
                                            dataIndex="ativ_data_checkin"
                                            title="Check-In"
                                            render={this.renderDataCheckIn}
                                            width={"14%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="ativ_data_checkout"
                                            dataIndex="ativ_data_checkout"
                                            title="Check-Out"
                                            render={this.renderDataCheckOut}
                                            width={"14%"}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                    </Table>
                                </div>
                            </div>
                        ) : null}

                        {/* ----------------------------------------------------------------- */}
                        {/* ----------------------------------------------------------------- */}
                        {/* ----------------------------------------------------------------- */}

                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default AtividadesVendedoresPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/AtividadesVendedoresPrintModal.js